<div class="row row-sm">
    <div class="col-lg-12">

        <div class="card-body">

            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.country-data.table.Country'| translate}}

                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.country-data.table.AddNewCountryRecord' | translate}}

                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.country-data.table.Country'| translate}}
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.country-data.table.UpdateCountryRecord' |
                                translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3 ">
                        <img alt="Logo" src="../../assets/img/CountryMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.country-data.table.Country'| translate}} </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.country-data.table.DeleteCountryRecord' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">
                <div class="row row-sm add-form ">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="CountryForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.country-data.table.CountryCode' |
                                                    translate }}
                                                </mat-label>

                                                <input appUppercase onkeydown="return (event.keyCode!=13);" [readonly]="isreadonly"
                                                    class="color" type="text" maxlength="5" [readonly]="isreadonlydel"
                                                    placeholder="Country Code" formControlName="CountryCode" matInput
                                                    required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="CountryForm.controls['CountryCode'].touched && CountryForm.controls['CountryCode'].errors?.required">
                                                    {{'header.country-data.table.Mandatory' |
                                                    translate }}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="CountryForm.controls['CountryCode'].touched && CountryForm.controls['CountryCode'].errors?.pattern">
                                                    {{'header.country-data.table.Invalid' |
                                                    translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.country-data.table.CountryName' |
                                                    translate }}
                                                </mat-label>
                                                <input appCamelcase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="25" [readonly]="isreadonlydel" placeholder="Country Name"
                                                    formControlName="CountryName" matInput required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="CountryForm.controls['CountryName'].touched && CountryForm.controls['CountryName'].errors?.required">
                                                    {{'header.country-data.table.Mandatory' |
                                                    translate }}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="CountryForm.controls['CountryName'].touched && CountryForm.controls['CountryName'].errors?.pattern">
                                                    {{'header.country-data.table.Invalid' |
                                                    translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 prpl">
                                    <div class="col-sm-12">
                                        <button id="Save" type="button" *ngIf="submitButton && CountryCreate"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="submit()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/save.gif"
                                                    style="margin-right: 5px;">
                                                {{'header.country-data.table.Save' |
                                                translate }}
                                            </span>
                                        </button>
                                        <button id="Update" type="button" *ngIf="editButton && CountryUpdate"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1" (click)="update()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/edit1.gif"
                                                    style="margin-right: 5px;">
                                                 {{'header.country-data.table.Update' |
                                                translate }}
                                            </span>
                                        </button>
                                        <button id="Delete" type="button" *ngIf="deleteButton && CountryDelete"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1"
                                            (click)="openConformationModalBox()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/trash.gif"
                                                    style="margin-right: 5px;">
                                                {{'header.country-data.table.Delete' |
                                                translate }}
                                            </span>
                                        </button>
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="20vh"  src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                {{'header.country-data.table.Back' |
                                                translate }}
                                            </span>
                                        </button>

                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>